import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { repayMoneyFormAction, selectAction } from "../../redux/rootReducer";
import { repayMoneyForSubscriptionSagaAction } from "../../redux/sagaActions";
import Select from "../Select/Select";
import { SELECT_INITIAL } from "../../redux/initialStateConstant";

const RepayMoneyForm = () => {
    const dispatch = useDispatch();
    const repay_money_form = useSelector(state => state.repay_money_form);
    const payment_methods = useSelector(state => state.payment_methods);

    if (!repay_money_form.open) return false;

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close"
                            onClick={ () => dispatch(repayMoneyFormAction({
                                open: false,
                                subscription_id: '',
                                sum: '',
                                payment_method: { id: '', name: '' }
                            })) }
                        />
                        <div className="form__title">Возврат средств</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Сумма возврата</div>
                        <input type="text" className="input" autoFocus
                            value={ repay_money_form.sum }
                            onInput={ event => dispatch(repayMoneyFormAction({
                                ...repay_money_form,
                                sum: event.target.value
                            })) }
                        />
                    </div>
                    {
                        payment_methods.length > 0
                            ?
                            <div className="form__field">
                                <div className="input__caption">Метод оплаты</div>
                                <Select
                                    current={ repay_money_form.payment_method.name }
                                    type={ 'payment_method' }
                                    options={ payment_methods }
                                    handler={ elem => {
                                        dispatch(repayMoneyFormAction({
                                            ...repay_money_form,
                                            payment_method: elem
                                        }));
                                        dispatch(selectAction(SELECT_INITIAL));
                                    } }
                                    smart={ false }
                                />
                            </div>
                            : false
                    }
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                if (window.confirm('Вы действительно хотите произвести возврат средств за абонемент?')) {
                                    dispatch(repayMoneyForSubscriptionSagaAction({
                                        subscription_id: repay_money_form.subscription_id,
                                        sum: repay_money_form.sum,
                                        payment_method: repay_money_form.payment_method.id
                                    }));
                                }
                            } }
                        >
                            Вернуть
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RepayMoneyForm;